import "./src/styles/global.css"
import { initPosthog, capturePageview } from "./src/utils/posthog"

export const onClientEntry = () => {
  initPosthog()
}

// Also fires on the initial page load (after onClientEntry), so this alone
// covers every pageview — no separate capture call needed in onClientEntry.
export const onRouteUpdate = ({ location }) => {
  capturePageview(location.pathname)
}
